import React, { useState } from 'react';
import {IconButton,Tooltip} from '@mui/material';
import { RestartAlt as RestartAltIcon } from '@mui/icons-material';

const StartNewChatButton = ({ handleNewChat }) => {

  return (
    <Tooltip title="Start a new chat">
        <IconButton
        onClick={handleNewChat}
        sx={{
            border: '1px solid #2EA1B6',
            borderRadius: '50%',
            width: 40,
            height: 40,
        }}
        >
            <RestartAltIcon />
        </IconButton>
    </Tooltip>
  );
};

export default StartNewChatButton;